export interface ExitOptionsKeyArguments {
  approvalId: string;
  currentStatus: string;
  roleName: string;
}

/**
 * Hierarchical query-key factory for the Workbench exit-screen options. Mirrors
 * the other feature key factories so cache invalidation stays predictable:
 * invalidating `all` flushes every exit-options query, `details()` flushes all
 * exit-options reads, and `detail({ approvalId, currentStatus, roleName })`
 * flushes a single lookup. Never write a literal key array outside this module —
 * the factory IS the schema.
 *
 * Keyed on all three inputs the BFF requires (approvalId path + currentStatus &
 * roleName query params), so the allowed transitions re-fetch whenever any of
 * them changes.
 */
export const exitOptionsKeys = {
  all: ["exitOptions"] as const,
  details: () => [...exitOptionsKeys.all, "detail"] as const,
  detail: (arguments_: ExitOptionsKeyArguments) => [...exitOptionsKeys.details(), arguments_] as const,
};
